(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["xummit-analytics"] && !Shopify.designMode) return;
  try {
    (() => {
  let privacyReady = false;
  const allowed = () => privacyReady && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const publish = (event, data = {}) => {
    if (!allowed() || typeof window.Shopify?.analytics?.publish !== 'function') return;
    try { Promise.resolve(window.Shopify.analytics.publish('xummit:' + event, {language:document.documentElement.lang, ...data})).catch(() => {}); } catch {}
  };
  const quote = document.querySelector('[data-quote-form]');
  const simulator = document.querySelector('xummit-light-lab');
  let quoteStarted = false, simulatorUsed = false, successTracked = false;
  const success = () => {
    if (successTracked || !document.querySelector('[data-quote-success]') || !allowed()) return;
    let pending;
    try { pending = Number(sessionStorage.getItem('xummit-quote-attempt')); sessionStorage.removeItem('xummit-quote-attempt'); } catch {}
    if (!pending || Date.now()-pending>3600000) return;
    successTracked = true; publish('quote_submitted');
  };
  const ready = () => { privacyReady = true; success(); };
  if (window.Shopify?.customerPrivacy) ready();
  else if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], error => { if (!error) ready(); });
  document.addEventListener('visitorConsentCollected', success);
  if (quote) {
    quote.addEventListener('input', () => { if (!quoteStarted && allowed()) { quoteStarted = true; publish('quote_started'); } });
    quote.addEventListener('submit', () => {
      if (!quote.checkValidity() || !allowed()) return;
      try { sessionStorage.setItem('xummit-quote-attempt',String(Date.now())); } catch {}
    });
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('a'); if (!link) return;
    if (link.hasAttribute('data-technical-sheet')) publish('technical_sheet_download_clicked',{model:link.dataset.model,language:link.dataset.language});
    else if (link.hasAttribute('data-catalog-download')) publish('catalog_download_clicked');
    else {
      try { const url = new URL(link.href); if (url.origin === location.origin && /\/pages\/quote\/?$/.test(url.pathname)) publish('quote_cta_clicked'); } catch {}
    }
  });
  if (simulator) {
    const use = () => { if (!simulatorUsed && allowed()) { simulatorUsed = true; publish('simulator_used'); } };
    simulator.addEventListener('input',use); simulator.addEventListener('change',use); simulator.addEventListener('pointerdown',use); simulator.addEventListener('keydown',use);
    simulator.addEventListener('xummit-layout-exported',()=>publish('simulator_layout_exported'));
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["xummit-behavior"] && !Shopify.designMode) return;
  try {
    (() => {
  const cfgNode = document.getElementById('x-config');
  if (!cfgNode) return;
  const cfg = JSON.parse(cfgNode.textContent);
  const root = cfg.root.replace(/\/$/, '') + '/';
  document.querySelectorAll('.nav-item').forEach(details=>details.addEventListener('toggle',()=>{if(details.open) document.querySelectorAll('.nav-item[open]').forEach(other=>{if(other!==details)other.open=false;});}));
  document.addEventListener('click',event=>{if(!event.target.closest('.x-header'))document.querySelectorAll('.x-header details[open]').forEach(item=>item.open=false);});
  document.addEventListener('keydown',event=>{if(event.key==='Escape') document.querySelectorAll('.x-header details[open]').forEach(item=>item.open=false);});
  document.querySelectorAll('[data-tabs]').forEach(group=>{
    const tabs=[...group.querySelectorAll('[role=tab]')];
    const select=tab=>tabs.forEach(item=>{const selected=item===tab;item.setAttribute('aria-selected',String(selected));item.tabIndex=selected?0:-1;document.getElementById(item.getAttribute('aria-controls')).hidden=!selected;});
    tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>select(tab));tab.addEventListener('keydown',event=>{let next;if(event.key==='ArrowRight')next=tabs[(index+1)%tabs.length];if(event.key==='ArrowLeft')next=tabs[(index+tabs.length-1)%tabs.length];if(event.key==='Home')next=tabs[0];if(event.key==='End')next=tabs[tabs.length-1];if(next){event.preventDefault();select(next);next.focus();}});});
  });
  const dialog=document.getElementById('x-lightbox');
  if(dialog){dialog.querySelector('button').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});}
  document.querySelectorAll('[data-gallery]').forEach(gallery=>{
    const main=gallery.querySelector('[data-zoom]'),img=main.querySelector('img'),caption=gallery.querySelector('[data-gallery-caption]');
    if(!img)return;
    gallery.querySelectorAll('.gallery-thumb').forEach(thumb=>thumb.addEventListener('click',()=>{img.removeAttribute('srcset');img.src=thumb.dataset.full;img.alt=thumb.dataset.alt;caption.textContent=thumb.dataset.caption;main.classList.toggle('is-photo',thumb.dataset.photo==='true');gallery.querySelectorAll('.gallery-thumb').forEach(item=>item.setAttribute('aria-pressed',String(item===thumb)));}));
    main.addEventListener('click',()=>{dialog.querySelector('img').src=img.currentSrc||img.src;dialog.querySelector('img').alt=img.alt;dialog.querySelector('p').textContent=caption.textContent;dialog.showModal();});
  });
  const quote=document.querySelector('[data-quote-form]');
  if(quote){
    const params=new URLSearchParams(location.search),select=quote.querySelector('#QuoteProduct'),application=quote.querySelector('#QuoteApplication'),message=quote.querySelector('#QuoteMessage');
    const aliases={'fuji':'FUJI','sierra':'SIERRA','atlas':'ATLAS','fuji-additional-battery':'FUJI Additional Battery','fuji-external-charger':'FUJI External Charger','mochila-xummit':'MOCHILA XUMMIT'};
    const selected=aliases[params.get('product')]||params.get('product');
    if(select&&!select.value&&selected&&[...select.options].some(item=>item.value===selected))select.value=selected;
    if(application&&!application.value&&[...application.options].some(item=>item.value===params.get('application')))application.value=params.get('application');
    if(message&&!message.value&&params.get('project'))message.value=params.get('project').slice(0,4000);
    quote.querySelector('[data-quote-success],.quote-errors')?.focus();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["xummit-hero-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('xummit-hero-carousel')) {
  customElements.define('xummit-hero-carousel', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-hero-slide]')];
      if (this.slides.length < 2) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.buttons = [...this.querySelectorAll('[data-hero-select]')];
      this.toggle = this.querySelector('[data-hero-toggle]');
      this.controls = this.querySelector('.xh-controls');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.index = Math.max(0, this.slides.findIndex(slide => slide.classList.contains('is-active')));
      this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
      this.visible = true;
      this.delay = Math.max(4000, Number(this.dataset.interval) || 5000);
      this.controls.hidden = false;
      this.slides.slice(1).forEach(slide => {
        const image = slide.querySelector('img');
        if (image) image.loading = 'eager';
      });
      this.buttons.forEach((button, index) => button.addEventListener('click', () => {
        this.show(index);
        this.schedule();
      }, options));
      this.toggle.addEventListener('click', () => {
        this.paused = !this.paused;
        this.schedule();
      }, options);
      this.addEventListener('focusin', event => {
        if (!this.contains(event.relatedTarget) && event.target !== this.toggle && event.target.matches(':focus-visible')) {
          this.paused = true;
          this.schedule();
        }
      }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', event => {
        if (event.matches) this.paused = true;
        this.schedule();
      }, options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.schedule();
      }, { threshold: 0 });
      this.observer.observe(this);
      this.show(this.index);
      this.schedule();
    }

    show(index) {
      this.index = index;
      this.slides.forEach((slide, position) => {
        const active = position === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
        this.buttons[position].setAttribute('aria-pressed', String(active));
      });
    }

    schedule() {
      clearTimeout(this.timer);
      this.toggle.textContent = this.paused ? this.dataset.playLabel : this.dataset.pauseLabel;
      this.querySelector('.xh-slides').setAttribute('aria-live', this.paused ? 'polite' : 'off');
      if (this.paused || !this.visible || document.hidden) return;
      this.timer = setTimeout(() => {
        const next = (this.index + 1) % this.slides.length;
        const image = this.slides[next].querySelector('img');
        if (!image || (image.complete && image.naturalWidth > 0)) this.show(next);
        this.schedule();
      }, this.delay);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.events?.abort();
      this.observer?.disconnect();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
